export default [
    {
      id: '1faddb4b-12f0-41f8-1c2d-fa7ae01ffeb2',
      slug: 'junior-react-developer-at-startup-x',
      company: 'Startup X',
      title: 'Junior React Developer',
      salary: undefined,
      location: undefined,
      applyAt: 'http://startup-x.com/apply',
      promoImageUrl: 'http://www.cvrunning.com/wp-content/uploads/2017/06/textured-background.jpg',
      createdBy: 'b237f1f2-455c-476b-bcbb-66a92c0fc7e2',
      views: 20165,
      clicks: 1207,
    },
    {
      id: '1faddb4b-12f0-41f8-1c2d-fa7ae01ffeb1',
      slug: 'junior-ruby-on-rails-developer-at-startup-x',
      company: 'Startup X',
      title: 'Junior Ruby on Rails Developer',
      salary: '$46,000',
      location: 'Berlin',
      applyAt: 'http://startup-x.com/apply',
      promoImageUrl: 'https://previews.123rf.com/images/aerial3/aerial31606/aerial3160600066/58204178-gravel-textur-overlay-subtile-korn-textur-auf-wei%C3%9Fem-hintergrund-abstract-grunge-wei%C3%9Fen-und-schwarzen-.jpg',
      createdBy: 'b237f1f2-455c-476b-bcbb-66a92c0fc7e2',
      views: 31084,
      clicks: 3042,
    },
    {
      id: '6dfddb5a-56e1-11e8-9c2d-0a7ae01bbeb9',
      slug: 'senior-nodejs-engineer-at-enterprise-y',
      company: 'Enterprise Y',
      title: 'Senior NodeJS Engineer',
      salary: '$120,000',
      location: 'Austin',
      applyAt: 'http://www.enteprise-y.org/apply?tech=nodejs',
      promoImageUrl: 'https://i.pinimg.com/564x/f8/4a/be/f84abe02e8335d342f393ddb8b34cbff.jpg',
      createdBy: '572dcd9a-9f92-44d0-a83a-b8876b3d5776',
      views: 39319,
      clicks: 2012,
    },
    {
      id: 'a6bddb5a-a6a1-120f-0c1d-9a7ae01baeb7',
      slug: 'react-developer-company-abc',
      company: 'Company ABC',
      title: 'React Developer',
      salary: '$72,000',
      location: 'London',
      applyAt: 'https://company-abc.co.uk/jobs/react-developer',
      promoImageUrl: 'https://i.pinimg.com/236x/4a/1e/94/4a1e94eaf3f874b2a35ddc52bd457737--tyger-black-white.jpg',
      createdBy: '0b69521a-0030-40f2-816c-d4b9d564428b',
      views: 40351,
      clicks: 2421,
    },
    {
      id: '0df1dc5a-56e4-cce8-9c1d-0c71e01bfebf',
      slug: 'fullstack-javascript-engineer-companxy-xyz',
      company: 'Company XYZ',
      title: 'Full-stack JavaScript Engineer',
      salary: '$134,000',
      location: 'San Francisco',
      applyAt: 'https://xyz.us/jobs',
      promoImageUrl: 'https://i.pinimg.com/236x/4a/1e/94/4a1e94eaf3f874b2a35ddc52bd457737--tyger-black-white.jpg',
      createdBy: 'd1e094f4-7182-4ab7-8f7c-86236f4f22f1',
      views: 41287,
      clicks: 2963,
    },
    {
      id: '44fddb5a-d390-01e8-bc2f-ba4a809bb3bc',
      slug: 'ai-internship-at-zeta',
      company: 'Company Zeta',
      title: 'AI Intern',
      salary: '$270 per week',
      location: 'New York City',
      applyAt: 'http://wwww.zetacomp.co/internships',
      promoImageUrl: 'https://i.pinimg.com/236x/4a/1e/94/4a1e94eaf3f874b2a35ddc52bd457737--tyger-black-white.jpg',
      createdBy: 'ae561f37-5aaf-49e5-856b-36ff7ca3d07b',
      views: 38579,
      clicks: 1905,
    }
  ];
  